
import axios from "axios";
import CryptoJS from "crypto-js";
// const crypto = require("crypto");

export const baseurl = "https://openapi.suntrustng.com/NINLinkage/api/BVNNIN";

// export const baseurl = "https://digitalbanking.suntrustng.com:8443/NINLinkage/api/BVNNIN/";


export const njokkhksmdjbfds = "Watetsenpcryniot";

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      resolve(reader.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };
  });
};

const v = "Watetsenpcryniot";


export const et = (data) => {
  const key = CryptoJS.enc.Utf8.parse(v);

  const encrypted = CryptoJS.AES.encrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
};

export const dt = (data) => {
  // console.log("DT", data);
  const ciphertext = data;
  const key = CryptoJS.enc.Utf8.parse(v);

  const decryptedBytes = CryptoJS.AES.decrypt(ciphertext, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return CryptoJS.enc.Utf8.stringify(decryptedBytes);
};

export const callFunction = async (appendUrl, Data) => {
  const body = JSON.stringify(Data);

  // console.log("BODY",body);
  const lakadosh = et(body);

  let data = JSON.stringify({ Data: lakadosh });

  // console.log(data);

  var config = {
    method: "POST",
    url: `https://openapi.suntrustng.com/NINLinkage/api/BVNNIN/${appendUrl}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  const response = await axios(config);
//   console.log("RESPONSE", response);
  const dekrpt = dt(response?.data);

//   console.log("DECRYPT", dekrpt);

  return JSON.parse(dekrpt);
};

export const callFunctionTwo = async (appendUrl, Data) => {
  const body = JSON.stringify(Data);

  const lakadosh = et(body);

  let data = JSON.stringify({ Data: lakadosh });

  var config = {
    method: "POST",
    url: `https://openapi.suntrustng.com/NINLinkage/api/BVNNIN/${appendUrl}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  const response = await axios(config);
//   console.log("DEC1", response)
  const dekrpt = dt(response?.data?.data);

//   console.log("DEC2", dekrpt)
  return JSON.parse(dekrpt);
};
export const callFunctionTwoTwo = async (appendUrl, Data) => {
  const body = JSON.stringify(Data);

  const lakadosh = et(body);

  let data = JSON.stringify({ Data: lakadosh });

  var config = {
    method: "POST",
    url: `https://openapi.suntrustng.com/NINLinkage/api/BVNNIN/${appendUrl}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  const response = await axios(config);
  // console.log("DEC1", response)
  const dekrpt = dt(response?.data?.data);

  // console.log("DEC2", dekrpt)
  return JSON.parse(dekrpt);
};

export const callFunctionThree = async (appendUrl, Data) => {
  const body = JSON.stringify(Data);

  const lakadosh = et(body);

  let data = JSON.stringify({ Data: lakadosh });

  var config = {
    method: "POST",
    url: `https://openapi.suntrustng.com/STBAccountUpgrade/api/${appendUrl}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  const response = await axios(config);
  // console.log("DEC1", response?.data)
  const dekrpt = dt(response?.data?.data);

//   console.log("DEC2", dekrpt);
  return JSON.parse(dekrpt);
  // return response?.data
};

export const callFunctionFour = async (appendUrl, Data) => {
  const body = JSON.stringify(Data);

  const lakadosh = et(body);

  let data = JSON.stringify({ Data: lakadosh });

  // console.log("TOBE SENT", data)

  var config = {
    method: "POST",
    url: `https://openapi.suntrustng.com/NINLinkage/api/BVNNIN/${appendUrl}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  const response = await axios(config);

//   console.log("FINAK", response)

  if (response?.data?.code === "96") {
    return response?.data;
  } else {
    const dekrpt = dt(response?.data?.data);

    return JSON.parse(dekrpt);
  }
};
